var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute bottom-0 left-0 right-0 bg-orange-600 p-3",on:{"click":_vm.clear}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }